import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import '@angular/common/locales/global/ru';
import { SpellCountPipe } from './app/shared/pipes/spell-count/spell-count.pipe';
import { environment } from './environments/environment';
import { providePrimeNG } from 'primeng/config';
import { MyPresetUikit } from './styles/themes/mypreset';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideAngularSvgIcon } from 'angular-svg-icon';

registerLocaleData('ru');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    MessageService,
    ConfirmationService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPresetUikit,
        options: {
          darkModeSelector: '.dark'
        },
      },

      translation: {
        dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        today: 'Сегодня',
        clear: 'Очистить',
        weekHeader: 'Нед',
      },
    }),
    [{ provide: LOCALE_ID, useValue: 'ru-RU' }],
    importProvidersFrom(
      IonicStorageModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    provideAngularSvgIcon(),
    provideIonicAngular({
      backButtonText: '',
    }),
    provideRouter(APP_ROUTES),
    DatePipe,
    CurrencyPipe,
    SpellCountPipe,
  ],
}).catch((err) => console.log(err));
